import { combineReducers } from 'redux'
import poster from './poster'
import selection from './selection'

const rootReducer = combineReducers({
    poster,
    selection
})

export default rootReducer